import {CrudModel} from '@ngx-ivengi/crud';

export class Warranty extends CrudModel {
  public name: string;
  public file: FileList;
  public fileId: string;
  public fileName: string;
  public fileSrc: string = '';
  public customerId: string = '';
  public customer: {id: string, name: string};

  public setName(name: string): Warranty {
    if(typeof name === 'string') {
      this.name = name;
    }
    return this;
  }

  public setFile(files: FileList): Warranty {
    if(files instanceof FileList) {
      this.file = files;
    }
    return this;
  }

  public setFileId(fileId: string): Warranty {
    if(typeof fileId === 'string') {
      this.fileId = fileId;
    }
    return this;
  }

  public setFileName(fileName: string): Warranty {
    if(typeof fileName === 'string') {
      this.fileName = fileName;
    }
    return this;
  }

  public setFileSrc(fileSrc: string): Warranty {
    if(typeof fileSrc === 'string') {
      this.fileSrc = fileSrc;
    }
    return this;
  }

  public setCustomerId(customerId: string): Warranty {
    if(typeof customerId === 'string') {
      this.customerId = customerId;
    }
    return this;
  }

  public setCustomer(customer: {id: string, name: string}): Warranty {
    if(customer instanceof Object) {
      this.customer = customer;
    }
    return this;
  }

  fromResponse(response: any): void {
    this
      .setId(response.id)
      .setName(response.name)
      .setCustomerId(response.customerId)
      .setCustomer(response.customer);

    if(response.file) {
      this
        .setFileId(response.file.id)
        .setFileName(response.file.name);
    }
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/warranty/warranty.model.ts